var map = {
	"./review-01.jpg": 10819,
	"./review-02.jpg": 25864,
	"./review-03.jpg": 64600,
	"./review-04.jpg": 86469,
	"./review-img-02.png": 4995,
	"./review-img-03.png": 6675,
	"./review-img.png": 40516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15824;